import { render, staticRenderFns } from "./indexForRedirectPage.vue?vue&type=template&id=132e9ee2&scoped=true&"
import script from "./indexForRedirectPage.vue?vue&type=script&lang=js&"
export * from "./indexForRedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./indexForRedirectPage.vue?vue&type=style&index=0&id=132e9ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e9ee2",
  null
  
)

export default component.exports